import * as buf from "buffer/";

export let process = { env: {} };

export let Buffer = buf.Buffer;
